module.exports = __webpack_public_path__ + "static/media/pet-profile-pic.30e61499.svg";